module.exports = __webpack_public_path__ + "img/text-jdcw.13320cce.png";